module.exports = {"152221100":"科尔沁镇","152221101":"索伦镇","152221102":"德伯斯镇","152221103":"大石寨镇","152221104":"归流河镇","152221105":"居力很镇","152221106":"察尔森镇","152221107":"额尔格图镇","152221108":"俄体镇","152221200":"满族屯满族乡","152221201":"乌兰毛都苏木","152221202":"阿力得尔苏木","152221203":"巴日嘎斯台乡","152221204":"桃合木苏木","152221400":"跃进马场","152221401":"索伦牧场","152221403":"阿力得尔牧场","152221404":"公主陵牧场","152221405":"绿水种畜繁育中心","152221407":"科右前旗工业园区","152221408":"科右前旗现代农牧业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/152221.json
// module id = 567
// module chunks = 0